import { render, staticRenderFns } from "./DocumentCustomFields.vue?vue&type=template&id=101256a4"
import script from "./DocumentCustomFields.vue?vue&type=script&lang=js"
export * from "./DocumentCustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports